/** Mapeo nombre → componente de ícono, sólo para ítems de navegación
 *  (AppSidebar/BottomNav): el nombre queda desacoplado de qué librería lo
 *  resuelve, y sirve de punto único si algún día un nombre de ícono viene
 *  de afuera (una config, no sólo código) en vez de estar siempre auditado
 *  en tiempo de compilación.
 *
 *  El resto de los íconos del layout (chevron de un dropdown/acordeón, pin,
 *  logout, sol/luna) siguen como imports directos de `lucide-react` en su
 *  propio componente — no pasan por acá a propósito, no hay ninguna razón
 *  para indireccionar un ícono que un solo lugar del código usa una vez.
 */

import {
  Activity,
  ArrowRightLeft,
  Bell,
  Bot,
  Calendar,
  Circle,
  Database,
  FlaskConical,
  HelpCircle,
  History,
  Landmark,
  LayoutDashboard,
  LayoutGrid,
  Layers,
  ListOrdered,
  NotebookPen,
  Receipt,
  ScrollText,
  Settings,
  Trash2,
  Users,
  TrendingUp,
  type LucideIcon,
} from 'lucide-react'

export const ICON_MAP: Record<string, LucideIcon> = {
  dashboard: LayoutDashboard,
  bots: Bot,
  history: History,
  transactions: Receipt,
  calendar: Calendar,
  alerts: Bell,
  journal: NotebookPen,
  exchanges: ArrowRightLeft,
  matrix: LayoutGrid,
  runs: ListOrdered,
  walkforward: TrendingUp,
  data: Database,
  strategies: Layers,
  taxReport: Landmark,
  settings: Settings,
  help: HelpCircle,
  // Encabezados de sección del sidebar, ver AppSidebar.tsx.
  operations: Activity,
  users: Users,
  logs: ScrollText,
  trash: Trash2,
  research: FlaskConical,
}

//: Nombre sin mapear — no debería pasar nunca con los nombres que arma el
//: propio código, pero fallar con un ícono neutro es mejor que un crash.
const FALLBACK_ICON: LucideIcon = Circle

export function Icon({
  name,
  className,
  size,
}: {
  name: string
  className?: string
  size?: number
}) {
  const Component = ICON_MAP[name] ?? FALLBACK_ICON
  return <Component className={className} size={size} />
}
